export default "__VITE_ASSET__C8HMj1jV__"